import { NextPage } from "next";
import MaintenanceContainer from "../components/organisms/maintenanceContainer";

const Maintenance: NextPage = () => <MaintenanceContainer />;

export default Maintenance;
